import { render, staticRenderFns } from "./UserTables.vue?vue&type=template&id=934cea3c&scoped=true&"
import script from "./UserTables.vue?vue&type=script&lang=js&"
export * from "./UserTables.vue?vue&type=script&lang=js&"
import style0 from "./UserTables.vue?vue&type=style&index=0&id=934cea3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934cea3c",
  null
  
)

export default component.exports